import { Routes, Route, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
export const isEmpty = (val) => {
    return !Boolean(val);
}

export const splitTimeFromDateTime = (time) => {
    if (isEmpty(time)) {
        var date = "";
        var time = "";
        return { date, time }
    }
    let splitarray = time.split(" ");
    var date = splitarray[0];
    var time = splitarray[1] + " " + splitarray[2];
    return { date, time };
}

export const titleCase = (str) => {
    return str.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
}

export const alertGeneraliseMessage = (severity) => {
    let msg = "Selections saved successfully";
    if (severity == "success")
        return "Selections saved successfully";
    if (severity == "error")
        return "Selections NOT SAVED. Please try again.";
    return msg;
}

export const getNumWeeksFromNow = (numOfWeeks, date) => {
    let newDate = new Date(date)
    newDate.setDate(date.getDate() + numOfWeeks * 7);
    return newDate;
}

export const convertDateToIsoString = (date) => {
    
   let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
   let day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
   // return date.toISOString().split('T')[0].replace('-', '-')
}

export const convertDateToMMDDYYYYString = (date, separator) => {
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
   return [mnth, day, date.getFullYear()].join(separator);
 }
 
export const addMonths = (numOfMonths, date) => {
    date.setMonth(date.getMonth() + numOfMonths);
    return date;
}

export const subtractMonths = (numOfMonths, date) => {
    date.setMonth(date.getMonth() - numOfMonths);
    return date;
}

export const displayDate = (date) => {
    let display = date.toDateString();
    let splitarray = display.split(" ");
    return splitarray[1] + " " + splitarray[2] + " " + splitarray[3];
}
// method compares firstElement and hsVal 
// this method returns the index of the dropdown range for a historic value.
export const handleHistoricValue = (firstElement,hsVal,index) => {
        console.log( index + "historic parameterssss")
        if ((hsVal < firstElement) && index > 0) {
            return index -1
        } else if((hsVal < firstElement) && (index - 1 < 0)) {
            return index;
        } else {
            return 2 ;
        }
    
}

export const displayDateComaYear = (date) => {
    let display = date.toDateString();
    let splitarray = display.split(" ");
    return splitarray[1] + " " + splitarray[2] + ", " + splitarray[3];
}

export const CheckIsUserAdmin = () => {
    const navigate = useNavigate();
    //const personDetails = useSelector((state) => state.person.personData);
    const personStaticDetails = useSelector((state) => state.personStatic.personStaticData);
    if(personStaticDetails.avail_admin === null) {
        navigate("/somethingwentwrong", {state:`Unautorized Access...Please contact administrator`});
    } else {
        return
    }     
}


export const toUpperCaseString = (str) => {
    if(Boolean(str)){
      return str.toUpperCase();
    }
    return str;
}

export const isString = (str) => {
    if(isNaN(str)) {
        return true;
    } else {
        return false;
    }
}